import React, { useState } from 'react';
import { API_BASE_URL, GraphicTypeContainer, renderModal, closeModal} from './Common';
import './ChartWidgetCreator.css';
import axios from 'axios';

function ChartWidgetCreator({
  tableColumnData,
  isTablesLoaded,
  tables,
  projectId,
  setDashboards
}) {

  const [selectedDatasets, setselectedDatasets] = useState([]);
  const [graphType, setGraphType] = useState('');
  const [newWidgetName, setnewWidgetName] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [modalIconId, setModalIconId] = useState(1);

const handleCreateWidget = async () => {
  try {
    const token = localStorage.getItem('token');

const newDashboardData = {
    name: newWidgetName,
    databaseId: projectId,
    theme: 1,
    widgets: []
};

const response = await axios.post(`${API_BASE_URL}/dashboards`, newDashboardData, {
    headers: {
        Authorization: `Bearer ${token}` // Include JWT token in Authorization header
    }
});

const firstKey = Object.keys(response.data.duplicatedDashboard)[0];
const newDashboard = response.data.duplicatedDashboard[firstKey];

setDashboards(prevDashboards => ({ ...prevDashboards, [firstKey]: newDashboard }));

    setModalMessage("Dashboard criado!");
      setModalMessageColor('#41BBC9');
      setModalIconId(1);
      setIsModalOpen(true);

  } catch (error) {
    setModalMessage("Dashboard com erros...");
      setModalMessageColor('#E5004E');
      setModalIconId(2);
      setIsModalOpen(true);
  }
};


  return (
  <div className="home-container" style={{ paddingLeft: '0px', paddingTop: '0px' }}>
      <h2>Gerir dashboards</h2>
      <p>Criar dashboard</p>

    <div className="create-project">
          <label className="project-name-label">Nome do Dashboard</label>
    <input
    type="text"
    placeholder="Inserir nome do dashboard"
    onChange={(e) => setnewWidgetName(e.target.value)}
    />

    <div className="lists-container">
    </div>

    <GraphicTypeContainer
        title="Criar um novo"
        topics={[
          'Personalizar da forma que melhor se adpatar às necessidades dos dados a serem apresentados'
        ]}
        selectedDatasets={selectedDatasets}
        tableColumnData={tableColumnData}
        setGraphType={setGraphType}
        graphType={graphType}
        chartGroup={8}
      />


  {graphType && (
    <button
    className="button"
    onClick={() => handleCreateWidget(selectedDatasets, graphType)}>Guardar Dashboard</button>
)}
  </div>

{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}
  </div>
);

}



export default ChartWidgetCreator;
